import { ProfileOnboarding } from "@/models/Profile.model";

export const validateProfileOnboarding = (
  values: ProfileOnboarding
): { isValid: boolean; error: string | null } => {
  if (values.firstName === null || values.firstName === "") {
    return { isValid: false, error: "You must enter your first name." };
  }

  if (values.lastName === null || values.lastName === "") {
    return { isValid: false, error: "You must enter your last name." };
  }

  if (values.nationality === null) {
    return { isValid: false, error: "You must choose a nationality." };
  }

  if (values.countryOfResidence === null) {
    return { isValid: false, error: "You must choose a country of residence." };
  }

  if (values.gender === null) {
    return { isValid: false, error: "You must choose a gender" };
  }

  if (values.dateOfBirth === null) {
    return { isValid: false, error: "You must enter your date of birth." };
  }

  if (!hasPhoneInput(values.phoneNumber ?? "")) {
    return { isValid: false, error: "You must enter a phone number" };
  }

  return { isValid: true, error: null };
};

export const hasPhoneInput = (phoneValue: string): boolean => {
  if (!phoneValue) return false;
  const numberOnly = phoneValue.replace(/\D/g, "");
  return numberOnly.length >= 6;
};
